import React from 'react';
import { FONTS, SCREEN_PADDING_LARGE, TYPOGRAPHY } from '@/styles';
import { OrderItemQuantityBox } from '@/components/order-item-quantity-box';
import { StyleSheet, Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  formattedPrice: string | null;
  quantity: number;
  subtitle: React.ReactNode | null;
  title: string | null;
}

export const InvoiceListItem: React.FC<Props> = ({
  formattedPrice,
  quantity,
  subtitle,
  title,
}) => {
  const { isLargeLayout } = useLayoutContext();

  return (
    <View
      style={[isLargeLayout ? styles.mainContentLarge : styles.mainContent]}
    >
      {isLargeLayout ? (
        <>
          <View style={styles.quantityBoxWrapperLarge}>
            <OrderItemQuantityBox quantity={quantity} />
          </View>
          <View style={styles.titleDescriptionContainer}>
            <Text
              numberOfLines={2}
              style={[TYPOGRAPHY.medium, FONTS.primarySemiBold]}
            >
              {title}
            </Text>
          </View>
          {subtitle ? (
            <View style={styles.subtitleLarge}>{subtitle}</View>
          ) : null}
          <View style={styles.totalPriceLarge}>
            <Text style={TYPOGRAPHY.medium}>{formattedPrice}</Text>
          </View>
        </>
      ) : (
        <>
          <View style={styles.quantityBoxWrapper}>
            <OrderItemQuantityBox quantity={quantity} />
          </View>
          <View style={styles.mainContentRight}>
            {title ? (
              <View style={styles.titleContainer}>
                <Text numberOfLines={2} style={FONTS.primarySemiBold}>
                  {title}
                </Text>
              </View>
            ) : null}
            <View style={styles.subtitle}>{subtitle}</View>
          </View>
          <Text style={TYPOGRAPHY.medium}>{formattedPrice}</Text>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContent: {
    flex: 1,
    flexDirection: 'row',
  },
  mainContentLarge: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContentRight: {
    flex: 1,
  },
  quantityBoxWrapper: {
    marginRight: 12,
  },
  quantityBoxWrapperLarge: {
    justifyContent: 'center',
    marginRight: 12,
  },
  subtitle: {
    flexShrink: 0,
  },
  subtitleLarge: {
    alignItems: 'center',
    flex: 2,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: SCREEN_PADDING_LARGE,
  },
  titleContainer: {
    marginBottom: 16,
  },
  titleDescriptionContainer: {
    flex: 3,
    justifyContent: 'center',
  },
  totalPriceLarge: {
    alignItems: 'flex-end',
    flex: 1,
    justifyContent: 'center',
  },
});
